import { QueryClient } from 'react-query'

/**
 * Query keys whose data is derived from which sub-organization owns a workflow.
 *
 * A workflow has a single owner, so assigning one changes every one of these at
 * once: the catalogue's `isAssigned` / `assignedTo`, the parent's sub-org list
 * counts, one sub-organization's own `workflowCount`, the owning sub-org's
 * workflow list, and the workflow's own owner. They are declared together
 * because a mutation that refreshes only some of them leaves the rest serving a
 * world where the workflow is still free (sc-9836).
 */
export const WORKFLOW_CATALOGUE_QUERY_KEY = 'get-workflow-catalogue'
export const SUB_ORGANIZATIONS_QUERY_KEY = 'get-sub-organizations'
export const SUB_ORGANIZATION_QUERY_KEY = 'get-sub-organization'
export const SUB_ORG_WORKFLOWS_QUERY_KEY = 'get-sub-org-workflows'
export const WORKFLOW_SUB_ORGANIZATION_QUERY_KEY = 'get-workflow-sub-organization'

export const WORKFLOW_ASSIGNMENT_QUERY_KEYS = [
  WORKFLOW_CATALOGUE_QUERY_KEY,
  SUB_ORGANIZATIONS_QUERY_KEY,
  // The detail page header reads `workflowCount` from this query while its
  // Workflows tab reads the list from another — refreshing only the list leaves
  // the count above it contradicting the rows below.
  SUB_ORGANIZATION_QUERY_KEY,
  SUB_ORG_WORKFLOWS_QUERY_KEY,
  WORKFLOW_SUB_ORGANIZATION_QUERY_KEY,
]

/**
 * Marks every assignment-derived cache stale after a workflow changes owner.
 *
 * Each key is invalidated by prefix, so sidebar catalogues held under a
 * non-default sort/filter and other sub-organizations' workflow lists refresh
 * too — the caller rarely knows which of those the user has already loaded.
 */
export const invalidateWorkflowAssignments = (queryClient: QueryClient): Promise<void[]> => (
  Promise.all(
    WORKFLOW_ASSIGNMENT_QUERY_KEYS.map(key => queryClient.invalidateQueries([key])),
  )
)
